import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ACTION_TYPES } from "../constants";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { requestAddStudentsToSpaceReservation } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import useDialogAddStudentError from "./useDialogAddStudentError";
import ReservationErrorHandled from "../ReservationErrorHandled";

const useAddStudent = ({
    reservationId,
    studentList,
    studentsSelectedToUse,
    setStudentsSelectedToUse,
    addActionTypeToListActions
}) => {
    const { loadingRequestOfReservationAction } = useResourcesUniversitySpacesContext();
    const dialogAddStudentConfirmation = useShowDialogAlert();
    const dialogStudentAddedSuccessfully = useShowDialogAlert();
    const dialogStudentAlreadyAdded = useShowDialogAlert();
    const dialogAddStudentError = useDialogAddStudentError();
    //#region Functions
    function studentAlreadyExistsInReservationList() {
        return studentList.value.some(({ id }) => {
            return studentsSelectedToUse.some((studentSelected => id === studentSelected.id));
        });
    }
    function addStudentToReservationList() {
        dialogAddStudentConfirmation.hide();
        if (studentAlreadyExistsInReservationList()) {
            dialogStudentAlreadyAdded.open();
            return;
        }
        studentList.add(studentsSelectedToUse[0]);
        dialogStudentAddedSuccessfully.open();
        addActionTypeToListActions(ACTION_TYPES.ADD);
    }
    function confirmAddStudent(studentToAdd) {
        setStudentsSelectedToUse([studentToAdd]);
        dialogAddStudentConfirmation.open();
    }
    async function doRequestAddStudentToReservationList() {
        loadingRequestOfReservationAction.show("Agregando alumno(s)...");
        const data = await requestAddStudentsToSpaceReservation({
            reservationId,
            students: studentList.getStudentsNotSaved()
        });
        loadingRequestOfReservationAction.hide();
        if (data.success) 
            return;
        const isErrorHandled = dialogAddStudentError.open(data);
        if (isErrorHandled)
            throw new ReservationErrorHandled();
        throw new Error();
    }
    //#endregion
    return {
        fns: {
            addStudentToReservationList,
            confirmAddStudent,
            doRequestAddStudentToReservationList
        },
        dialogs: {
            dialogAddStudentConfirmation,
            dialogStudentAddedSuccessfully,
            dialogStudentAlreadyAdded,
            dialogAddStudentError
        }
    };
}	
    
export default useAddStudent;